import { Badge, Card,  CardBody} from "reactstrap";
import { Rating } from "react-simple-star-rating";
import { JOB_DATA } from "../../../Data/JobSearch";
import { H4, Image, P, Ribbon } from "../../../AbstractElements";
import { Href } from "../../../Constant";
import { Link } from "react-router-dom";
import { dynamicImage } from "../../../Service/DynamicImage";

const ListViewCard = () => {
  return (
    <>
      {JOB_DATA.slice(0, 8).map((item) => (
          <Card key={item.id} className={`${item.ribbion ? "ribbon-vertical-left-wrapper" : "pb-3"}`}>
            {item.ribbion ? (
              <Ribbon className={`ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary ${!item.ribbion && "d-none"}`}>
                <i className="icofont icofont-love"></i>
              </Ribbon>
            ) : ("")}
            <div className="job-search">
              <CardBody>
                <div className="d-flex">
                  <Image className="img-40 b-r-0 img-fluid m-r-20" width="40" height="40" src={dynamicImage(`${item.logo}`)} alt="job logo"/>
                  <div className="flex-grow-1">
                    <H4 className="f-w-700">
                      <Link to={Href}>{item.job_name}</Link>
                      {item.type === "new" ? (<Badge color="primary" className="pull-right">{item.badgeValue}</Badge>) : (<span className="pull-right">{item.type}</span>)}
                    </H4>
                    <P>
                      {item.job_area}, {item.job_city}
                      <Rating className="rating ms-1" initialValue={Math.random()*5} size={14} />
                    </P>
                  </div>
                </div>
                <P>{item.Job_description}</P>
              </CardBody>
            </div>
          </Card>
        ))}
    </>
  );
};
export default ListViewCard;
